import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/defer';
import { ApiService } from '../api.service';

export interface ParametersBody {
  type: string,
  additionalProperties: any
}

@Injectable()
export class ParametersService {

  private options: any;

  constructor(
    private apiService: ApiService
  ) { }


  getParameters(section): Observable<any[]>  {
    return this.apiService.client.parameters.section(section).GET(this.options)
    .map((res) => {
      return this.apiService.handleResponse(res);
    });
  }

  patchParameters(section, body) {
    return this.apiService.client.parameters.section(section).PATCH(body)
    .map((res) => {
      return this.apiService.handleResponse(res);
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/core/api/parameters.service.ts